import { Stack, Typography, Box, Grid, useTheme, useMediaQuery } from "@mui/material";
import {
  CleaningServices,
  CheckCircle,
  VpnKey,
  Chat,
  LocationOn,
  LocalOffer,
} from "@mui/icons-material";
import Header from "../../../components/Header";

const Achievements = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const allStats = [
    { title: "Cleanliness", rating: "5.0", icon: CleaningServices },
    { title: "Accuracy", rating: "4.9", icon: CheckCircle },
    { title: "Check-in", rating: "5.0", icon: VpnKey },
    { title: "Communication", rating: "5.0", icon: Chat },
    { title: "Location", rating: "4.9", icon: LocationOn },
    { title: "Value", rating: "4.9", icon: LocalOffer },
  ];

  // Show all 6 stats on mobile (below sm), only first 5 on larger screens
  const stats = isMobile ? allStats : allStats.slice(0, 5);

  return (
    <Box maxWidth={1000} mx="auto" my={12} mb={{ xs: 12, sm: 24 }} px={2}>
      <Header
        label="Achievements"
        title="Reputation that counts"
        desc="One of the most loved homes on Airbnb, according to guests"
      />

      {/* Grid Layout */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gridTemplateRows: {
            xs: "auto",
            sm: "min-content min-content",
            md: "auto auto",
          },
          gap: { xs: 2, sm: 3 },
          mt: { xs: 4, sm: 6 },
          alignItems: "stretch",
        }}
      >
        {/* Rating Card */}
        <Box
          sx={{
            gridColumn: { xs: "1 / -1", sm: "span 1", md: "span 2" },
            gridRow: { xs: "auto", sm: "span 2" },
            background: "linear-gradient(180deg, #E4DD6070 0%, #ffffff10 100%)",
            backdropFilter: "blur(10px)",
            p: 4,
            borderRadius: 8,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            bgcolor: "rgba(255, 255, 255, 0.10)",
            pt: 6
          }}
          // data-aos="zoom-in"
          data-aos-delay={100}
        >
          <picture>
            <source srcSet={`/images/about-us/rating.webp`} type="image/webp" />
            <img src="/images/about-us/rating.png" width="100%" alt="" />
          </picture>
          <Box mx="auto" width="fit-content" pt={1}>
            <Stack
              alignItems="center"
              direction="row"
              justifyContent="center"
              spacing={2}
            >
              <picture>
                <source
                  srcSet={`/images/about-us/airbnb.webp`}
                  type="image/webp"
                />
                <img
                  src="/images/about-us/airbnb.png"
                  height={32}
                  width={32}
                  alt=""
                />
              </picture>
              <Typography
                variant="body1"
                fontWeight={500}
                color="text.secondary"
              >
                Ranked top 5% villas in Goa
              </Typography>
            </Stack>
          </Box>
        </Box>

        {/* Stats Cards */}
        {stats.map((stat, idx) => {
          const IconComponent = stat.icon;
          return (
            <Box
              key={idx}
              sx={{
                p: 3,
                borderRadius: 8,
                bgcolor: "rgba(255, 255, 255, 0.1)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              data-aos="zoom-in"
              data-aos-delay={(idx + 1) * 100}
            >
              <Stack
                spacing={2}
                alignItems="center"
                justifyContent="center"
                sx={{
                  height: "100%",
                  minHeight: "160px",
                }}
              >
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  width={56}
                  height={56}
                  border="1px solid #ffffff70"
                  borderRadius={100}
                  boxSizing="border-box"
                  pt={1}
                >
                  <Box color="accent.main">
                    <IconComponent fontSize="small" />
                  </Box>
                </Stack>
                <Stack alignItems="center" spacing={0.5}>
                  <Typography
                    variant="h4"
                    fontWeight={700}
                    fontSize={{ xs: "1.8rem", md: "2.5rem" }}
                  >
                    {stat.rating}
                  </Typography>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    color="text.secondary"
                    fontSize={{ xs: "0.75rem", md: "0.85rem" }}
                  >
                    {stat.title}
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Achievements;
